import translate from "@/utilities/i18n/getTranslate";
import { k } from "@/utilities/i18n";
export var bundlesDetails = {
    "Partner Growth Plan": {
        value: "growth",
        description: translate(k.BILL_perfectForPlatforms),
        benefits: [
            translate(k.BILL_growthPartnerSupportResponse4h),
            translate(k.BILL_growthMetaSupportEscalations),
            translate(k.BILL_growthPartnerLedBusinessVerification),
            translate(k.BILL_growthCoMarketing),
            translate(k.BILL_monthToMonth)
        ]
    },
    "Partner Premium Plan": {
        value: "premium",
        description: translate(k.BILL_skipTheQueue),
        benefits: [
            translate(k.BILL_premiumPartnerSupportResponse1h),
            translate(k.BILL_premiumMetaSupportEscalations),
            translate(k.BILL_premiumDedicatedPartnerManager),
            translate(k.BILL_premiumPartnerLedBusinessVerification),
            translate(k.BILL_premiumCoMarketing),
            translate(k.BILL_premiumMarketplaceEligibility),
            translate(k.BILL_premiumNegativeBalanceThreshold),
            translate(k.BILL_monthToMonth)
        ]
    },
    "Partner Sandbox Plan": {
        value: "sandbox",
        description: "",
        benefits: []
    },
    "Partner Starter Plan": {
        value: "starter",
        description: translate(k.BILL_starterForPlatforms),
        benefits: [
            translate(k.BILL_starterPartnerSupportResponse24h),
            translate(k.BILL_growthMetaSupportEscalations),
            translate(k.BILL_growthCoMarketing),
            translate(k.BILL_monthToMonth)
        ]
    }
};
var defaultBundleDetail = {
    value: "",
    description: "",
    benefits: []
};
// Safely retrieves bundle display details for a plan name. Unknown plan names return a fallback with empty description/benefits instead of undefined, so the UI renders gracefully
export var getBundleDetails = function (planName) {
    var _a;
    return (_a = bundlesDetails[planName]) !== null && _a !== void 0 ? _a : defaultBundleDetail;
};
//# sourceMappingURL=data:application/json;base64,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